/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable arrow-parens */
/* eslint-disable max-len */
// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import classnames from 'classnames';

// =================react_leaflet=================
import {
  MapContainer, TileLayer, FeatureGroup,
} from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';

// ==================Style&IMG===================
import './style.scss';
// Import css Leaflet Draw
import 'leaflet-draw/dist/leaflet.draw.css';
import iconUrl from '../../../assets/images/black.png';

// =================Composants===================
import Markers from './Markers';
import UseMap from './UseMap';

// ===================ACTIONS======================
// import {
//   setClickOnNetworks,
//   setNetworksArray, setNewList, setSelectAllClick, setSelectInactive, setToolsCheckbox, toggleBackgroundImage, toggleNetworkMenu,
// } from '../../../actions/site';
// import { setChargingNewListStations } from '../../../actions/dataAPI';
import {
  setClickOnNetworks,
  setNetworksArray,
  setSelectAllClick,
  setSelectInactive,
  setToolsCheckbox,
  toggleBackgroundImage,
  toggleNetworkMenu,
} from '../../../actions/site';

function MapLeaflet() {
  // ==================HOOKS=========================
  const dispatch = useDispatch();
  const center = useSelector((state) => state.site.map.center);
  const buttonImage = useSelector((state) => state.site.map.miniatureBackground);
  const mapURL = useSelector((state) => state.site.map.mapURL);
  const dataAPI = useSelector((state) => state.dataAPI.stations.list);
  const newListStations = useSelector((state) => state.dataAPI.stations.newList);
  const chargingNewList = useSelector((state) => state.dataAPI.stations.chargingNewList);
  const loadingMap = useSelector((state) => state.site.map.loadingMap);
  const mapResults = useSelector((state) => state.site.map.mapResults);
  const markersColors = useSelector((state) => state.site.markersColors);
  const tools = useSelector((state) => state.site.networks.tools);
  const openNetworksMenu = useSelector((state) => state.site.networks.openNetworksMenu);
  const networks = useSelector((state) => state.site.networks.listNetworks);
  const networkClick = useSelector((state) => state.site.networks.networkClick);
  const selectAllClick = useSelector((state => state.site.networks.selectAllClick));
  const selectInactiveClick = useSelector((state) => state.site.networks.selectInactive);

  // ================Handler=======================
  function handleBackgroundImage() {
    dispatch(toggleBackgroundImage());
  }

  function handleOpenNetworksMenu() {
    dispatch(toggleNetworkMenu());
  }

  // ================classnames=====================

  const miniatureBackground = classnames('mapbuttonid', { 'mapbuttonid--road': buttonImage });
  const displayNetworksMenu = classnames('dropdown--menu--column--close', { 'dropdown--menu--column--open': openNetworksMenu });

  // ================functions=====================
  // function allowing you to define the color of markers according to their networks TOTO MOVE THIS FUNCTION TO USEMAP COMPONENT AND USE MYMAP.EACHLAYER ...
  // eslint-disable-next-line no-unused-vars
  function colorMarker() {
    const color = markersColors;
    color.forEach((elemcolor) => {
      const colorOfMarker = document.getElementsByClassName(elemcolor.name[0]);
      if (elemcolor.borderColor) {
        for (let i = 0; i < colorOfMarker.length; i += 1) {
          colorOfMarker[i].style.fill = `#${elemcolor.color}`;
          colorOfMarker[i].style.fillOpacity = 0.6;
          colorOfMarker[i].style.stroke = `#${elemcolor.borderColor}`;
          colorOfMarker[i].style.strokeWidth = 2;
          colorOfMarker[i].style.strokeOpacity = 0.8;
        }
      }
      else {
        for (let i = 0; i < colorOfMarker.length; i += 1) {
          colorOfMarker[i].style.fill = `#${elemcolor.color}`;
          colorOfMarker[i].style.fillOpacity = 0.6;
          colorOfMarker[i].style.stroke = 'grey';
          colorOfMarker[i].style.strokeWidth = 0.5;
        }
      }
    });
  }

  useEffect(() => {
    // Re‑colorie dès que la liste change ET que les marqueurs sont rendus
    if (chargingNewList) {
      // léger délai pour laisser Leaflet insérer le SVG
      const id = setTimeout(colorMarker, 100);
      return () => clearTimeout(id);
    }
  }, [chargingNewList, newListStations]);

  // Memoize colors of makers
  // useMemo(() => {
  //   setTimeout(() => {
  //     colorMarker();
  //   }, 1000);
  // });

  // creation of list of marker and memoize her
  let markerComponents = [];
  // if (newListStations !== undefined) {
  markerComponents = useMemo(() => newListStations.map((marker) => (
    <Markers
      key={marker.marker_long_name}
      shortName={marker.marker}
      longName={marker.marker_long_name}
      lon={marker.location.coordinates.lon}
      lat={marker.location.coordinates.lat}
      alt={marker.location.coordinates.altitude}
      installDate={marker.date_from}
      endDate={marker.date_to}
      country={marker.location.country.name}
      network={marker.network.name}
    />
  )));
  // }

  //  when launching page get click network to true
  useEffect(() => {
    dispatch(setClickOnNetworks(true));
  }, []);

  // When click on network get filter between network selecte dor not
  // useEffect(() => {
  //   if (networkClick === true) {
  //     dispatch(setClickOnNetworks(false));
  //     dispatch(setChargingNewListStations(false));
  //     const dataToSave = [];
  //     // const data = [];
  //     // dataAPI.data.map(x => data.push(x));
  //     const data = (newListStations.length ? [...newListStations] : [...dataAPI.data]);
  //     dataAPI.data.forEach((elTest) => {
  //       if (tools[1].checked) {
  //         networks.forEach((elNetwork) => {
  //           if (elNetwork.checked === false && elTest.network.name.includes(elNetwork.name[0])) {
  //             const pos = data.map(e => e.marker_long_name).indexOf(elTest.marker_long_name);
  //             if (pos !== -1) {
  //               data.splice(pos, 1);
  //             }
  //           }
  //         });
  //       }
  //       if (tools[1].checked === false) {
  //         networks.forEach((elNetwork) => {
  //           if (elNetwork.checked && elTest.network.name.includes(elNetwork.name[0])) {
  //             const savor = data.find((e) => e.marker === elTest.marker);
  //             if (dataToSave.find(e => e.marker_long_name === savor.marker_long_name) === undefined) {
  //               dataToSave.push(savor);
  //             }
  //           }
  //         });
  //       }
  //     });
  //     if (tools[1].checked) {
  //       dispatch(setNewList(data));
  //     }
  //     if (tools[1].checked === false) {
  //       dispatch(setNewList(dataToSave));
  //     }
  //     dispatch(setChargingNewListStations(true));
  //   }
  // }, [networkClick, newListStations]);

  // for all netork selected or not get new list of marker to diplay
  // useEffect(() => {
  //   if (selectAllClick === true) {
  //     dispatch(setSelectAllClick(false));
  //     if (tools[0].checked === true) {
  //       // dispatch(setNewList(dataAPI.data));
  //       const listOfNetworkChecked = [];
  //       networks.forEach((el) => {
  //         listOfNetworkChecked.push(el);
  //       });
  //       listOfNetworkChecked.forEach((el) => {
  //         el.checked = true;
  //       });
  //       dispatch(setNetworksArray(listOfNetworkChecked));
  //       const listOfCheckedBox = document.getElementsByClassName('checkedBox');
  //       for (let i = 0; i < listOfCheckedBox.length; i += 1) {
  //         listOfCheckedBox[i].checked = true;
  //       }
  //     }
  //     if (tools[0].checked === false) {
  //       // dispatch(setNewList([]));
  //       const listOfNetworkUnchecked = [];
  //       networks.forEach((el) => {
  //         listOfNetworkUnchecked.push(el);
  //       });
  //       listOfNetworkUnchecked.forEach((el) => {
  //         el.checked = false;
  //       });
  //       dispatch(setNetworksArray(listOfNetworkUnchecked));
  //       const listOfCheckedBox = document.getElementsByClassName('checkedBox');
  //       for (let i = 0; i < listOfCheckedBox.length; i += 1) {
  //         listOfCheckedBox[i].checked = false;
  //       }
  //     }
  //   }
  // }, [selectAllClick]);

  // for all inactive station selected or not get new list of marker to diplay
  // useEffect(() => {
  // if (selectInactiveClick === true) {
  //   let elNetworkChecked = false;
  //   let data = [];
  //   let data2 = '';
  //   dataAPI.data.map(x => data.push(x));
  //   dispatch(setSelectInactive(false));
  //   if (tools[1].checked === false) {
  //     dataAPI.data.forEach((elTest) => {
  //       if (tools[0].checked) {
  //         networks.forEach((elNetwork) => {
  //           if (elNetwork.checked === false && elTest.network.name.includes(elNetwork.name[0])) {
  //             elNetworkChecked = true;
  //             const pos = data.map(e => e.marker).indexOf(elTest.marker);
  //             if (pos !== -1) {
  //               data.splice(pos, 1);
  //             }
  //             data.forEach((del) => {
  //               if (del.date_to !== null) {
  //                 const pos2 = data.map(e => e.date_to).indexOf(del.date_to);
  //                 if (pos2 > -1) {
  //                   data.splice(pos2, 1);
  //                 }
  //               }
  //             });
  //           }
  //         });
  //         if (elNetworkChecked === false) {
  //           data.forEach((del) => {
  //             if (del.date_to !== null) {
  //               const pos2 = data.map(e => e.date_to).indexOf(del.date_to);
  //               if (pos2 > -1) {
  //                 data.splice(pos2, 1);
  //               }
  //             }
  //           });
  //         }
  //       }
  //       if (tools[0].checked === false) {
  //         networks.forEach((elNetwork2) => {
  //           if (elNetwork2.checked === false && elTest.network.name.includes(elNetwork2.name[0])) {
  //             elNetworkChecked = true;
  //             const pos = data.map(e => e.marker).indexOf(elTest.marker);
  //             if (pos !== -1) {
  //               data.splice(pos, 1);
  //             }
  //             data.forEach((del) => {
  //               if (del.date_to !== null) {
  //                 const pos2 = data.map(e => e.date_to).indexOf(del.date_to);
  //                 if (pos2 > -1) {
  //                   data.splice(pos2, 1);
  //                 }
  //               }
  //             });
  //           }
  //         });
  //         if (elNetworkChecked === false) {
  //           data.forEach((del) => {
  //             if (del.date_to !== null) {
  //               const pos2 = data.map(e => e.date_to).indexOf(del.date_to);
  //               if (pos2 > -1) {
  //                 data.splice(pos2, 1);
  //               }
  //             }
  //           });
  //         }
  //       }
  //     });
  //   }
  //   if (tools[1].checked) {
  //     dataAPI.data.forEach((elTest) => {
  //       if (tools[0].checked) {
  //         networks.forEach((elNetwork) => {
  //           if (elNetwork.checked === false && elTest.network.name.includes(elNetwork.name[0])) {
  //             elNetworkChecked = true;
  //             const pos = data.map(e => e.marker_long_name).indexOf(elTest.marker_long_name);
  //             if (pos !== -1) {
  //               data.splice(pos, 1);
  //             }
  //           }
  //         });
  //       }
  //       if (tools[0].checked === false) {
  //         networks.forEach((elNetwork) => {
  //           if (elNetwork.checked && (elTest.network.name.includes(elNetwork.name[0]) || elTest.date_to !== null)) {
  //             elNetworkChecked = true;
  //             if (data2.length === 0) {
  //               data2 += `${elTest.marker_long_name},`;
  //             }
  //             else if (data2.length > 0 && data2.includes(elTest.marker) === false) {
  //               data2 += `${elTest.marker_long_name},`;
  //             }
  //           }
  //         });
  //         if (elNetworkChecked === false) {
  //           if (elTest.date_to !== null) {
  //             data2 += `${elTest.marker_long_name}`;
  //           }
  //         }
  //       }
  //     });
  //     if (data2 !== '') {
  //       data = [];
  //       dataAPI.data.forEach((x) => {
  //         if (data2.includes(x.marker_long_name)) {
  //           data.push(x);
  //         }
  //       });
  //     }
  //   }
  // dispatch(setNewList(data));
  // }
  // }, [selectInactiveClick]);

  // const handleClick = (event) => {
  //   const index = tools.find((el) => el.name === event.target.value);
  //   if (event.target.checked === false) {
  //     tools[1].checked = false;
  //     networks.forEach((el) => {
  //       el.checked = false;
  //     });
  //   }
  //   if (event.target.checked === true) {
  //     tools[1].checked = true;
  //     networks.forEach((el) => {
  //       el.checked = true;
  //     });
  //   }
  //   const indexof = tools.indexOf(index);
  //   tools[indexof].checked = !tools[indexof].checked;
  //   dispatch(setToolsCheckbox(tools));
  //   dispatch(setNetworksArray(networks));
  //   dispatch(setSelectAllClick(true));
  // };
  const handleClick = (e) => {
    const { checked } = e.target;

    // A. tools immuables
    // eslint-disable-next-line array-callback-return, consistent-return
    const newTools = tools.map((t, i) => {
      if (i === 0) return { ...t, checked };
      if (i === 1) return { ...t, checked };
    });

    // B. networks immuables
    const newNetworks = networks.map((n) => ({ ...n, checked }));

    dispatch(setToolsCheckbox(newTools));
    dispatch(setNetworksArray(newNetworks));
  };

  // const handleInactiveClick = (event) => {
  //   const index = tools.find((el) => el.name === event.target.value);
  //   const indexof = tools.indexOf(index);
  //   tools[indexof].checked = !tools[indexof].checked;
  //   dispatch(setToolsCheckbox(tools));
  //   dispatch(setSelectInactive(true));
  // };

  const handleInactiveClick = (e) => {
    const { checked } = e.target;
    const newTools = tools.map((t, idx) => (idx === 1 ? { ...t, checked } : t));
    dispatch(setToolsCheckbox(newTools));
  };

  // const handleClickNetworks = (event) => {
  //   const index = networks.find((el) => el.name[0] === event.target.value);
  //   const indexof = networks.indexOf(index);
  //   networks[indexof].checked = !networks[indexof].checked;
  //   dispatch(setNetworksArray(networks));
  //   dispatch(setClickOnNetworks(true));
  // };

  const handleClickNetworks = (e) => {
    const target = e.target.value;
    const newNetworks = networks.map((n) => (n.name[0] === target ? { ...n, checked: !n.checked } : n));
    dispatch(setNetworksArray(newNetworks));
  };

  return (
    <MapContainer
      center={center}
      gestureHandling
      gestureHandlingOptions={{
        // duration: 0,
        text: {
          // touch: 'Hey bro, use two fingers to move the map',
          scroll: '',
          // scrollMac: 'Hey bro, use \u2318 + scroll to zoom the map',
        },
      }}
      zoom={4}
      minZoom={2}
      scrollWheelZoom={false}
      style={{ width: '100%', height: '100%' }}
    >
      <button className={`${miniatureBackground}`} aria-label="background_image" type="submit" onClick={handleBackgroundImage} />
      <button type="button" className="dropdown--menu" onClick={handleOpenNetworksMenu}> Networks</button>

      <div className={displayNetworksMenu}>
        <div className="dropdown--width">
          <h4>Tools</h4>
          <input type="checkbox" className="input--selectAll" onChange={handleClick} name={tools[0].name} value={tools[0].name} checked={tools[0].checked} /> <p>{tools[0].name}</p>
          <input className="input--inactive checkedBox" type="checkbox" onChange={handleInactiveClick} name={tools[1].name} value={tools[1].name} checked={tools[1].checked} /> <img className="image--inactive" src={iconUrl} alt="inactive stations" /><p className="paragraph--inactive">Inactive Station</p>
          <p className="dropdown--width--paragraph">The selection her is only used for visualization and not for queries</p>
        </div>
        <div className="dropdown--width">
          <h4>Virtual</h4>
          {networks.filter((netw) => netw.name[0] === 'E-GVAP' || netw.name[0] === 'NFO_TABOO' || netw.name[0] === 'NFO_VRANCEA' || netw.name[0] === 'VOLC').map((filteredNames) => (
            <div key={filteredNames.name[0]}><input type="checkbox" className="checkedBox" value={filteredNames.name[0]} name={filteredNames.name[0]} onChange={handleClickNetworks} checked={filteredNames.checked} /><div style={{
              border: `2px #${filteredNames.borderColor} solid`, borderRadius: '50%',
            }}
            />
              <p>{filteredNames.name[0]}</p>
            </div>
          ))}
        </div>
        <div className="dropdown--width">
          <h4>International</h4>
          {networks.filter((netw) => netw.name[0] === 'EPN' || netw.name[0] === 'IGS').map((filteredNames) => (
            <div key={filteredNames.name[0]}><input type="checkbox" className="checkedBox" value={filteredNames.name[0]} name={filteredNames.name[0]} onChange={handleClickNetworks} checked={filteredNames.checked} /><div style={{
              border: `2px #${filteredNames.borderColor} solid`, borderRadius: '50%',
            }}
            />
              <p>{filteredNames.name[0]}</p>
            </div>
          ))}
        </div>
        <div className="dropdown--width">
          <h4>Local</h4>
          {networks.filter((netw) => netw.name[0] !== 'EPN' && netw.name[0] !== 'IGS' && netw.name[0] !== 'E-GVAP' && netw.name[0] !== 'NFO_TABOO' && netw.name[0] !== 'NFO_VRANCEA' && netw.name[0] !== 'VOLC').map((filteredNames) => (
            <div key={filteredNames.name[0] + filteredNames.color}><input type="checkbox" className="checkedBox" value={filteredNames.name[0]} name={filteredNames.name[0]} onChange={handleClickNetworks} checked={filteredNames.checked} /><div style={{
              backgroundColor: `#${filteredNames.color}`, borderRadius: '50%', opacity: '0.7',
            }}
            />
              <p>{filteredNames.name[0]}</p>
            </div>
          ))}
        </div>
      </div>
      <FeatureGroup>
        <EditControl
          position="topleft"
          draw={{
            marker: false,
            circlemarker: false,
            polyline: false,
          }}
          edit={{
            edit: false,
          }}
        />
      </FeatureGroup>

      <TileLayer
        url={mapURL}
        attribution="zoom: CTRL+SCROLL"
      />
      {(!loadingMap && mapResults && chargingNewList) && markerComponents}
      <UseMap />
    </MapContainer>
  );
}

export default MapLeaflet;
